import {
  GuidancePageCardItem,
  GuidancePageSection,
  PreparationChecklistAccordionItem,
} from "./types";

import {
  Info,
  Target,
  Star,
  SquareCheck,
  FileText,
  Award,
  CircleQuestionMark,
  Calendar,
  Share2,
  BookOpen,
  TrendingUp,
  RefreshCw,
  Home,
  FolderOpen,
  GraduationCap,
  Globe,
  BarChart3,
} from "lucide-react";

export const GUIDANCE_PAGE_ANCHOR_ITEMS: GuidancePageSection[] = [
  {
    key: "about",
    href: "#about",
    titleKey: "survey.guidancePage.aboutTheSurvey",
    icon: Info,
  },
  {
    key: "new",
    href: "#new-for-2026",
    titleKey: "survey.guidancePage.newFor2026",
    icon: Star,
  },
  {
    key: "checklist",
    href: "#checklist",
    titleKey: "survey.guidancePage.checklist",
    icon: SquareCheck,
  },
  {
    key: "how-to",
    href: "#how-to-complete",
    titleKey: "survey.guidancePage.howToCompleteTheSurvey",
    icon: FileText,
  },
  {
    key: "after",
    href: "#after-submission",
    titleKey: "survey.guidancePage.afterTheSubmission",
    icon: Award,
  },
  {
    key: "faq",
    href: "#faq",
    titleKey: "survey.guidancePage.faq",
    icon: CircleQuestionMark,
  },
  {
    key: "calendar",
    href: "#calendar",
    titleKey: "survey.guidancePage.calendar",
    icon: Calendar,
  },
];

export const CALENDAR_ITEMS: {
  key: string;
  dateKey: string;
  titleKey: string;
  descriptionKey: string;
  tagKey?: string;
}[] = [
  {
    key: "reporting-opens",
    dateKey: "survey.guidancePage.calendarReportingOpensDate",
    titleKey: "survey.guidancePage.calendarReportingOpensTitle",
    descriptionKey: "survey.guidancePage.calendarReportingOpensDescription",
  },
  {
    key: "informational-webinar",
    dateKey: "survey.guidancePage.calendarInformationalWebinarDate",
    titleKey: "survey.guidancePage.calendarInformationalWebinarTitle",
    descriptionKey:
      "survey.guidancePage.calendarInformationalWebinarDescription",
  },
  {
    key: "standard-deadline",
    dateKey: "survey.guidancePage.calendarStandardDeadlineDate",
    titleKey: "survey.guidancePage.calendarStandardDeadlineTitle",
    descriptionKey: "survey.guidancePage.calendarStandardDeadlineDescription",
  },
  {
    key: "late-deadline",
    dateKey: "survey.guidancePage.calendarLateDeadlineDate",
    titleKey: "survey.guidancePage.calendarLateDeadlineTitle",
    descriptionKey: "survey.guidancePage.calendarLateDeadlineDescription",
    tagKey: "survey.guidancePage.calendarLateDeadlineTag",
  },
];

export const FAQ_ITEMS: {
  key: string;
  questionKey: string;
  answerKey: string;
}[] = [
  {
    key: "what-is-sip",
    questionKey: "survey.guidancePage.faq1Question",
    answerKey: "survey.guidancePage.faq1Answer",
  },
  {
    key: "how-often",
    questionKey: "survey.guidancePage.faq2Question",
    answerKey: "survey.guidancePage.faq2Answer",
  },
  {
    key: "edit-after",
    questionKey: "survey.guidancePage.faq3Question",
    answerKey: "survey.guidancePage.faq3Answer",
  },
  {
    key: "miss-deadline",
    questionKey: "survey.guidancePage.faq4Question",
    answerKey: "survey.guidancePage.faq4Answer",
  },
  {
    key: "find-examples",
    questionKey: "survey.guidancePage.faq5Question",
    answerKey: "survey.guidancePage.faq5Answer",
  },
  {
    key: "who-involved",
    questionKey: "survey.guidancePage.faq6Question",
    answerKey: "survey.guidancePage.faq6Answer",
  },
];

export const ABOUT_THE_SIP_CARDS: GuidancePageCardItem[] = [
  {
    key: "share",
    icon: Share2,
    titleKey: "survey.guidancePage.aboutCardShareTitle",
    descriptionKey: "survey.guidancePage.aboutCardShareDescription",
  },
  {
    key: "inform",
    icon: BookOpen,
    titleKey: "survey.guidancePage.aboutCardInformTitle",
    descriptionKey: "survey.guidancePage.aboutCardInformDescription",
  },
  {
    key: "progress",
    icon: TrendingUp,
    titleKey: "survey.guidancePage.aboutCardProgressTitle",
    descriptionKey: "survey.guidancePage.aboutCardProgressDescription",
  },
];

export const NEW_FOR_2026_CARDS: GuidancePageCardItem[] = [
  {
    key: "simplified",
    icon: FileText,
    titleKey: "survey.guidancePage.newFor2026CardSimplifiedTitle",
    descriptionKey: "survey.guidancePage.newFor2026CardSimplifiedDescription",
  },
  {
    key: "goal",
    icon: Target,
    titleKey: "survey.guidancePage.newFor2026CardGoalTitle",
    descriptionKey: "survey.guidancePage.newFor2026CardGoalDescription",
  },
  {
    key: "reuse",
    icon: RefreshCw,
    titleKey: "survey.guidancePage.newFor2026CardReuseTitle",
    descriptionKey: "survey.guidancePage.newFor2026CardReuseDescription",
  },
  {
    key: "publication",
    icon: BookOpen,
    titleKey: "survey.guidancePage.newFor2026CardPublicationTitle",
    descriptionKey: "survey.guidancePage.newFor2026CardPublicationDescription",
  },
];

export const AFTER_SUBMISSION_CARDS: GuidancePageCardItem[] = [
  {
    key: "explore",
    icon: Globe,
    titleKey: "survey.guidancePage.afterSubmissionCardExploreTitle",
    descriptionKey: "survey.guidancePage.afterSubmissionCardExploreDescription",
  },
  {
    key: "data",
    icon: BarChart3,
    titleKey: "survey.guidancePage.afterSubmissionCardDataTitle",
    descriptionKey: "survey.guidancePage.afterSubmissionCardDataDescription",
  },
  {
    key: "reflect",
    icon: RefreshCw,
    titleKey: "survey.guidancePage.afterSubmissionCardReflectTitle",
    descriptionKey: "survey.guidancePage.afterSubmissionCardReflectDescription",
  },
];

export const PREPARATION_CHECKLIST_ACCORDIONS: PreparationChecklistAccordionItem[] =
  [
    {
      key: "set-up",
      icon: Home,
      titleKey: "survey.guidancePage.checklistSetUpTitle",
      items: [
        { id: "set-up-1", labelKey: "survey.guidancePage.checklistSetUpItem1" },
        { id: "set-up-2", labelKey: "survey.guidancePage.checklistSetUpItem2" },
        { id: "set-up-3", labelKey: "survey.guidancePage.checklistSetUpItem3" },
      ],
    },
    {
      key: "familiarize",
      icon: BookOpen,
      titleKey: "survey.guidancePage.checklistFamiliarizeTitle",
      items: [
        {
          id: "familiarize-1",
          labelKey: "survey.guidancePage.checklistFamiliarizeItem1",
        },
        {
          id: "familiarize-2",
          labelKey: "survey.guidancePage.checklistFamiliarizeItem2",
        },
        {
          id: "familiarize-3",
          labelKey: "survey.guidancePage.checklistFamiliarizeItem3",
        },
      ],
      exemplarySips: {
        introKey: "survey.guidancePage.checklistExemplarySurveysIntro",
        subsectionTitleKey:
          "survey.guidancePage.checklistExemplarySurveysTitle",
      },
    },
    {
      key: "organize",
      icon: FolderOpen,
      titleKey: "survey.guidancePage.checklistOrganizeTitle",
      items: [
        {
          id: "organize-1",
          labelKey: "survey.guidancePage.checklistOrganizeItem1",
        },
        {
          id: "organize-2",
          labelKey: "survey.guidancePage.checklistOrganizeItem2",
        },
        {
          id: "organize-3",
          labelKey: "survey.guidancePage.checklistOrganizeItem3",
        },
      ],
    },
    {
      key: "strategize",
      icon: Share2,
      titleKey: "survey.guidancePage.checklistStrategizeTitle",
      items: [
        {
          id: "strategize-1",
          labelKey: "survey.guidancePage.checklistStrategizeItem1",
        },
        {
          id: "strategize-2",
          labelKey: "survey.guidancePage.checklistStrategizeItem2",
        },
        {
          id: "strategize-3",
          labelKey: "survey.guidancePage.checklistStrategizeItem3",
        },
        {
          id: "strategize-4",
          labelKey: "survey.guidancePage.checklistStrategizeItem4",
        },
      ],
    },
    {
      key: "equip",
      icon: GraduationCap,
      titleKey: "survey.guidancePage.checklistEquipTitle",
      items: [
        { id: "equip-1", labelKey: "survey.guidancePage.checklistEquipItem1" },
        { id: "equip-2", labelKey: "survey.guidancePage.checklistEquipItem2" },
      ],
    },
  ];
